module.exports = __webpack_public_path__ + "img/1.5a1884a9.png";